export default __webpack_public_path__ + "static/media/HASSAN_FR_EPILOG1.aaea6baf.mp3";